import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import sbStyles from './sidebar.module.scss';

// const sidebarlist = [
//     {
//         title: 'services',
//         link: '/test'
//     }
// ]

export default function Sidebar() {
    const { t, i18n } = useTranslation();
    
    return (
        <div className={sbStyles.sidebar}>

            <ul className={sbStyles.sidebarList}>
                <li className={sbStyles.row} 
                id="active">
                    <Link to='/home' className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : '' }`}>{t('home')}</Link>
                </li>
                <li className={sbStyles.row}
                    id="active">
                    <Link to='/about' className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : ''}`}>{t('about')}</Link>
                </li>
                <li className={sbStyles.row} 
                id="active">
                    <Link to='/services' className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : '' }`}>{t('services')}</Link>
                </li>
                <li className={sbStyles.row} 
                id="active">
                    <Link to='/projects' className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : '' }`}>{t('projects')}</Link>
                </li>
                <li className={sbStyles.row}
                    id="active">
                    <Link to='/documents' className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : ''}`}>{t('documents')}</Link>
                </li>
                <li className={sbStyles.row} 
                id="active">
                    <Link to='/training' className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : '' }`}>{t('training')}</Link>
                </li>
                <li className={sbStyles.row} 
                id="active">
                    <Link to='/gallery' className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : '' }`}>{t('gallery')}</Link>
                </li>
                <li className={sbStyles.row} 
                id="active">
                    <Link to='/team' className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : '' }`}>{t('team')}</Link>
                </li>
                <li className={sbStyles.row}
                    id="active">
                    <Link to='/contact' className={`${sbStyles.link} ${i18n.language === 'ar' ? sbStyles.link_ar : ''}`}>{t('contact')}</Link>
                </li>
            </ul>

        </div>
    )
}